export default __webpack_public_path__ + "static/media/bg-2.bdf3fb4f.PNG";